import { Card, CardBody, Col, Input, InputGroup } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SegmentedButton, SegmentedButtonInfo, SegmentedButtonSecondary } from "../../../../Constant";
import { SEGMENT_BUTTON, SEGMENT_DATA_1, SEGMENT_DATA_2 } from "../../../../Data/FormControl/InputGroups";
import ButtonDropdownList from "../ButtonsWithDropdowns/Common/ButtonDropdownList";

const SegmentedButtons = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={SegmentedButton} span={SEGMENT_BUTTON} />
        <CardBody className="main-segment-btn card-wrapper input-group-wrapper">
          <InputGroup>
            <Btn color="info" outline> {SegmentedButtonInfo}</Btn>
            <ButtonDropdownList color="info" split={true} span={true} divider={true} options={SEGMENT_DATA_1}/>
            <Input type="text" />
          </InputGroup>
          <InputGroup>
            <Input type="text" />
            <Btn color="secondary" outline>{SegmentedButtonSecondary}</Btn>
            <ButtonDropdownList color="secondary" split={true} span={true} divider={true} options={SEGMENT_DATA_2}/>
          </InputGroup>
        </CardBody>
      </Card>
    </Col>
  )
};

export default SegmentedButtons;
